module.exports = __webpack_public_path__ + "aa70343db7f57f2ffaccec77c1f86d2a.MP3";